import { formatValue, colorByValue, statusToBg, statusToColor } from './formatValue';

function ListItem({ primary, secondary, meta, right_value, right_label, right_format, change, status, onClick }) {
    const rightDisplay = right_format ? formatValue(right_value, right_format) : right_value;
    const changeColor = colorByValue(change);
    const rightColor = right_format === 'percent' ? colorByValue(right_value) : 'text-gray-900 dark:text-gray-100';

    return (
        <div
            className={`flex items-center justify-between py-3 px-3 gap-3 ${onClick ? 'cursor-pointer hover:bg-gray-50 dark:hover:bg-white/5 rounded' : ''}`}
            onClick={onClick}
        >
            <div className="min-w-0 flex-1">
                <div className="text-sm font-semibold text-gray-900 dark:text-gray-100 truncate">{primary}</div>
                {secondary && (
                    <div className="text-xs text-gray-500 dark:text-gray-400 mt-0.5 truncate">{secondary}</div>
                )}
                {meta && (
                    <div className="text-xs text-gray-400 dark:text-gray-500 mt-0.5 truncate">{meta}</div>
                )}
            </div>
            {(rightDisplay != null || change != null || right_label) && (
                <div className="text-right flex-1">
                    {rightDisplay != null && (
                        <div className={`text-sm font-medium ${rightColor}`}>{rightDisplay}</div>
                    )}
                    {change != null && (
                        <div className={`text-xs font-medium ${changeColor}`}>
                            {formatValue(change, 'percent')}
                        </div>
                    )}
                    {right_label && (
                        <div className="text-xs text-gray-500 dark:text-gray-400">{right_label}</div>
                    )}
                </div>
            )}
        </div>
    );
}

function GroupHeader({ label, status, right_label }) {
    return (
        <div className="flex items-center justify-between mb-2 mt-4 first:mt-0">
            <span className={`text-xs font-semibold px-2.5 py-1 rounded ${statusToBg(status || 'neutral')}`}>
                {label}
            </span>
            {right_label && (
                <span className="text-xs text-gray-500 dark:text-gray-400">{right_label}</span>
            )}
        </div>
    );
}

export default function NativeList({ items, groups, title, subtitle, footer, variant }) {
    const isGrouped = variant === 'grouped' || groups;

    return (
        <div>
            {title && <div className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">{title}</div>}
            {subtitle && <div className="text-xs text-gray-500 dark:text-gray-400 mb-2">{subtitle}</div>}

            {isGrouped && groups ? (
                <div className="space-y-2">
                    {groups.map((group, gi) => (
                        <div key={gi}>
                            <GroupHeader label={group.label} status={group.status} right_label={group.right_label} />
                            <div className="bg-gray-50 dark:bg-white/5 rounded-lg overflow-hidden divide-y divide-gray-100 dark:divide-white/5">
                                {(group.items || []).map((item, ii) => (
                                    <ListItem key={ii} {...item} />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="bg-gray-50 dark:bg-white/5 rounded-lg overflow-hidden divide-y divide-gray-100 dark:divide-white/5">
                    {(items || []).map((item, i) => (
                        <ListItem key={i} {...item} />
                    ))}
                </div>
            )}

            {footer && (
                <div className="mt-3 pt-3 border-t border-gray-200 dark:border-white/10 space-y-1.5">
                    {footer.map((item, i) => (
                        <div key={i} className="flex justify-between text-sm">
                            <span className={item.status ? `font-medium ${statusToColor(item.status)}` : 'text-gray-500 dark:text-gray-400'}>
                                {item.label}
                            </span>
                            <span className={`font-medium ${item.status ? statusToColor(item.status) : 'text-gray-900 dark:text-gray-100'}`}>
                                {item.value}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export { ListItem, GroupHeader };
